function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { classnames } from '@bydesign-ui/utils';
import React, { Fragment } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { SkeletonAvatar } from './Avatar';
import { SkeletonParagraph } from './Paragraph';
import { SkeletonTitle } from './Title';

function getComponentProps(prop) {
  if (prop && _typeof(prop) === 'object') {
    return prop;
  }

  return {};
}

var getAvatarBasicProps = function getAvatarBasicProps(hasTitle, hasParagraph) {
  if (hasTitle && !hasParagraph) {
    return {
      shape: 'square'
    };
  }

  return {
    shape: 'circle'
  };
};

var getTitleBasicProps = function getTitleBasicProps(hasAvatar, hasParagraph) {
  if (!hasAvatar && hasParagraph) {
    return {
      width: '38%'
    };
  }

  if (hasAvatar && hasParagraph) {
    return {
      width: '50%'
    };
  }

  return {};
};

var getParagraphBasicProps = function getParagraphBasicProps(hasAvatar, hasTitle) {
  var basicProps = {};

  if (!hasAvatar || !hasTitle) {
    basicProps.width = '61%';
  }

  if (!hasAvatar && hasTitle) {
    basicProps.rows = 3;
  } else {
    basicProps.rows = 2;
  }

  return basicProps;
};

export function Skeleton(props) {
  var children = props.children,
      className = props.className,
      _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? true : _props$loading,
      _props$avatar = props.avatar,
      avatar = _props$avatar === void 0 ? {} : _props$avatar,
      _props$title = props.title,
      title = _props$title === void 0 ? true : _props$title,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? true : _props$paragraph,
      extra = _objectWithoutProperties(props, ["children", "className", "active", "loading", "avatar", "title", "paragraph"]);

  var hasAvatar = !!avatar;
  var hasTitle = !!title;
  var hasParagraph = !!paragraph;
  var avatarNode;
  var avatarCls = usePrefixCls('skeleton-header');
  var contentCls = usePrefixCls('skeleton-content');

  if (hasAvatar) {
    var avatarProps = _objectSpread(_objectSpread({}, getAvatarBasicProps(hasTitle, hasParagraph)), getComponentProps(avatar));

    avatarNode = React.createElement("div", {
      className: avatarCls
    }, React.createElement(SkeletonAvatar, Object.assign({}, avatarProps)));
  }

  var contentNode;

  if (hasTitle || hasParagraph) {
    var $title;

    if (hasTitle) {
      var titleProps = _objectSpread(_objectSpread({}, getTitleBasicProps(hasAvatar, hasParagraph)), getComponentProps(title));

      $title = React.createElement(SkeletonTitle, Object.assign({}, titleProps));
    }

    var paragraphNode;

    if (hasParagraph) {
      var paragraphProps = _objectSpread(_objectSpread({}, getParagraphBasicProps(hasAvatar, hasTitle)), getComponentProps(paragraph));

      paragraphNode = React.createElement(SkeletonParagraph, Object.assign({}, paragraphProps));
    }

    contentNode = React.createElement("div", {
      className: contentCls
    }, $title, paragraphNode);
  }

  var cls = classnames(usePrefixCls('skeleton', {
    active: active,
    loading: loading
  }), className);
  return React.createElement(Fragment, null, loading ? React.createElement("div", Object.assign({
    className: cls
  }, extra), avatarNode, contentNode) : children);
}